import { render, staticRenderFns } from "./IRadioButtons.vue?vue&type=template&id=33db6c1a&"
import script from "./IRadioButtons.vue?vue&type=script&lang=js&"
export * from "./IRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./IRadioButtons.vue?vue&type=style&index=0&id=33db6c1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports